import NewSimulationModal from "./NewSimulationModal";

interface CltModalProps {
  onBack: () => void;
}

export default function CltModal({ onBack }: CltModalProps) {
  return <NewSimulationModal onBack={onBack} />;
}
